module.exports = __webpack_public_path__ + "img/1.3822cf11.png";